import { IPaginationParams } from './shared.dto';
import { IZoomGroupDTO } from './zoom.dao';

abstract class IAccountAdminDAO {
    public abstract getAccountAdmin(params: IPaginationParams & Pick<ICommonSettingsDTO, 'accountId'>): Promise<IAccountAdminDTO>;
    public abstract updateDataAnonymization(params: IDataAnonymizationDTO): Promise<IDataAnonymizationDTO>;
    public abstract updateThirdPartyRegistrationData(params: IThirdPartyRegistrationDTO): Promise<IThirdPartyRegistrationDTO>;
    public abstract updateRecurringZoomMeetingsData(params: IRecurringZoomMeetingsDTO): Promise<IRecurringZoomMeetingsDTO>;
    public abstract updateComplianceEmailsData(params: IComplianceEmailDTO): Promise<IComplianceEmailDTO>;
    public abstract updateRegistrationApprovalData(params: IRegistrationApprovalDTO): Promise<IRegistrationApprovalDTO>;
    public abstract updateOrderBookingData(params: IOrderBookingDTO): Promise<IOrderBookingDTO>;
    public abstract updateSegregatedDataEncryptionData(params: ISegregatedDataEncryptionDTO): Promise<ISegregatedDataEncryptionDTO>;
    public abstract updateAccountSubdomainData(params: IAccountSubdomainDTO): Promise<IAccountSubdomainDTO>;
    public abstract updateOEPassportAuthenticationData(params: IOEPassportAuthenticationDTO): Promise<IOEPassportAuthenticationDTO>;
    public abstract updateURLParameterRegistrationData(params: IURLParameterRegistrationDTO): Promise<IURLParameterRegistrationDTO>;
    public abstract updateOEPassportAttendeeSSOData(params: IOEPassportAttendeeSSODTO): Promise<IOEPassportAttendeeSSODTO>;
    public abstract updateAIAgentAccessData(params: IAIAgentAccessDTO): Promise<IAIAgentAccessDTO>;
}

type TAccountAdminDTO = IDataAnonymizationDTO
    | IThirdPartyRegistrationDTO
    | IRecurringZoomMeetingsDTO
    | IComplianceEmailDTO
    | IRegistrationApprovalDTO
    | IAccountSubdomainDTO
    | IOrderBookingDTO
    | IOEPassportAuthenticationDTO
    | IURLParameterRegistrationDTO;
;
interface IAccountAdminDTO extends Array<TAccountAdminDTO> { }

interface ICommonSettingsDTO {
    accountId: number;
    type: AccountAdminSettingsType;
};

interface IDataAnonymizationDTO extends ICommonSettingsDTO {
    anonymizationEnabled: boolean;
    daysCountBeforeAnonymization: number;
};

interface IThirdPartyRegistrationDTO extends ICommonSettingsDTO {
    thirdPartyRegistrationEnabled: boolean;
};

interface IRecurringZoomMeetingsDTO extends ICommonSettingsDTO {
    recurringZoomMeetingsEnabled: boolean;
    allowedZoomGroups: IZoomGroupDTO[];
};

interface IComplianceEmailDTO extends ICommonSettingsDTO {
    complianceEmailCaptureEnabled: boolean;
    complianceEmails: string[];
};

interface IRegistrationApprovalDTO extends ICommonSettingsDTO {
    registrationApprovalEnabled: boolean;
    coordinatorDeniedNotificationsEnabled: boolean;
    requestAccessCodeRegistrationApprovalEnabled: boolean;
};

interface IOrderBookingDTO extends ICommonSettingsDTO {
    orderBookingEnabled: boolean;
    internalNotificationEmails: string[];
};
interface ISegregatedDataEncryptionDTO extends ICommonSettingsDTO {
    segregatedDataEncryptionEnabled: boolean;
};

interface IAccountSubdomainDTO extends ICommonSettingsDTO {
    accountSubdomainEnabled: boolean;
    subdomain: string | null;
};

interface IOEPassportAuthenticationDTO extends ICommonSettingsDTO { };

interface IURLParameterRegistrationDTO extends ICommonSettingsDTO {
    urlParameterRegistrationEnabled: boolean;
};

interface IOEPassportAttendeeSSODTO extends ICommonSettingsDTO {
    passportAttendeeSSOEnabled: boolean;
};

interface IAIAgentAccessDTO extends ICommonSettingsDTO {
    aiAgentAccessEnabled: boolean;
};

enum AccountAdminSettingsType {
    DATA_ANONYMIZATION = 'DATA_ANONYMIZATION',
    THIRD_PARTY_REGISTRATION = 'THIRD_PARTY_REGISTRATION',
    RECURRING_ZOOM_MEETINGS = 'RECURRING_ZOOM_MEETINGS',
    COMPLIANCE_EMAIL_CAPTURE = 'COMPLIANCE_EMAIL_CAPTURE',
    MANAGE_REGISTRATION_APPROVAL = 'REGISTRATION_APPROVAL',
    SEGREGATED_DATA_ENCRYPTION = 'SEGREGATED_DATA_ENCRYPTION',
    MANAGE_ORDER_BOOKING = 'ORDER_BOOKING',
    ACCOUNT_SUBDOMAIN = 'ACCOUNT_SUBDOMAIN',
    URL_PARAMETER_REGISTRATION = 'URL_PARAMETER_REGISTRATION',
    VIEW_EVENT_ATTRIBUTES = 'ATTRIBUTES',
    OE_PASSPORT_ATTENDEE_SSO = 'PASSPORT_ATTENDEE_SSO',
    AI_AGENT_ACCESS = 'AI_AGENT_ACCESS',
};

enum OrderBookingSubsets {
    DEFAULT = 'default'
}

export {
    IAccountAdminDAO,
    IAccountAdminDTO,
    IDataAnonymizationDTO,
    IThirdPartyRegistrationDTO,
    IRecurringZoomMeetingsDTO,
    AccountAdminSettingsType,
    IComplianceEmailDTO,
    IRegistrationApprovalDTO,
    ICommonSettingsDTO,
    TAccountAdminDTO,
    ISegregatedDataEncryptionDTO,
    IAccountSubdomainDTO,
    IOrderBookingDTO,
    OrderBookingSubsets,
    IOEPassportAuthenticationDTO,
    IURLParameterRegistrationDTO,
    IOEPassportAttendeeSSODTO,
    IAIAgentAccessDTO,
};
